import axios from 'axios';
import { useEffect, useState } from 'react'
import Box from 'elements/Box';
import { Avatar, AvatarGroup, Button, Chip, CircularProgress, Dialog, IconButton, Modal, Pagination, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { Link, useParams } from 'react-router-dom';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import {ProjectConfig} from 'Global';
import moment from 'moment';
import AlertDialog from 'elements/AlertDialog';
import AddIcon from '@mui/icons-material/Add';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import { useSnackbar } from 'notistack';

import 'assets/css/main.css'; 

import WarehouseEditor from './WarehouseEditor';
import { ApiRequest } from 'GlobalFunctions';

export default function WarehouseList(props: any) {

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const {setLoading} = props;

  useEffect(() => {
    setLoading(false);
  }, [])
  
  const [list, setList] = useState<any []>([]);
  const [total_pages, setTotalPages] = useState(0);

  const queryParams = new URLSearchParams(window.location.search);

  const [page, setPage] = useState(1);

  const [openEditor, setOpenEditor] = useState(false);



  useEffect(() => {
    setLoading(true);
    loadList();
  }, [page])

  /*=========================================================
  LOAD LIST
  =========================================================*/
  const loadList = async () => {
    setLoading(true);

    await ApiRequest({
      url: "/warehouses/list",
      method: "get",
      headers: {
        ltkn: localStorage.getItem("ltkn"),
      },
      query: {
        page: page,
      },
      setResponse: (response: any) => {
        setList(response.list);
        setTotalPages(response.total_pages);
        setLoading(false);
      },
    });
    
    // localStorage.setItem('page', page.toString())
}


  /*=========================================================*/



  /*=========================================================
  DELETE ITEM
  =========================================================*/

  const handleDelete = (warehouse_id:number) => {
    setActiveItem(warehouse_id)
    setOpenAlert(true)
  }



  const deleteItem = () => {

    const body = {
      warehouse_id: activeItem
    }

    axios.post(ProjectConfig.api_url+"/warehouses/deleteItem", body)
      .then((response) => {
        console.log(response.data);
        if(response.data.status === "success"){
          enqueueSnackbar('Bodega eliminada con éxito', { variant: 'success' });
          loadList();
        }
        
      })
      .catch((err) => {
        console.log(err.data);
      })
      .then(() => {
        setOpenAlert(false)
      })
  }
  

  /*=========================================================*/

// call global snackbar
  
const [openAlert, setOpenAlert] = useState(false);
const [activeItem, setActiveItem] = useState<any>(null);

  
  return (
      <div id='UsersList' className='ModuleContainer'>
        <div className="ModuleWrapper"> 
          <div className="boxContainerHeader">
            
            <div className="boxContainerTitle">
              <h2 className="h2_title">Bodegas</h2>
              <span className="h2_subtitle">Lista de bodegas creadas</span>
            </div>
            
            <div className="boxContainerActions">
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                setActiveItem(null)
                setOpenEditor(true)
              }}
              startIcon={<AddIcon />}
            >
              Crear bodega
            </Button>

            </div>
            
          </div>

          <div id='UsersListIn'>


            
              <Box id='WarehouseList' className='box100'>
              <TableContainer>
              <Table aria-label="sticky table"> 
                <TableHead>
                  <TableRow>
                    <TableCell  sx={{color:'#a8a8a8', borderBottom:"none"}}>BODEGA / CÓDIGO</TableCell>
                    <TableCell  sx={{color:'#a8a8a8', borderBottom:"none"}}>DIRECCIÓN / CIUDAD</TableCell>
                    <TableCell  sx={{color:'#a8a8a8', borderBottom:"none"}}></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                    {list.map((item,i) => (
                      <TableRow 
                        
                        key={i}
                        hover
                        role="checkbox"
                      >                      

                        <TableCell>
                        <span className='flex_title'>{item.warehouse_name}</span>
                        <span className='flex_subtitle'>{item.warehouse_code}</span>
                        </TableCell>

                        <TableCell>
                          <span className='flex_title'>{item.address}</span>
                          <span className='flex_subtitle'>{item.city}</span>
                        </TableCell>


                        <TableCell align="right">

                          <Button 
                            size="small"
                            variant="contained"
                            color="primary"
                            style={{"marginRight": "10px"}}
                            startIcon={<ModeEditIcon />}
                            onClick={() => {
                              setActiveItem(item.warehouse_id)
                              setOpenEditor(true)
                            }}
                          >
                            Editar
                          </Button>


                          
                          {(localStorage.getItem('role_id') === "1" || localStorage.getItem('role_id') === "2") &&
                          <IconButton aria-label="delete"  color="primary" onClick={() => handleDelete(item.warehouse_id)}>
                            <DeleteOutlineOutlinedIcon />
                          </IconButton>
                          }
                      </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
            
            <Pagination count={total_pages} page={page}  onChange={(event, value) => {
              setPage(value)
            }
            } 
            color="primary"
            style={{"marginTop": "20px","alignSelf": "center"}}
            />
            </Box>
  
          </div>
        </div>

        <AlertDialog
            open={openAlert}
            setOpen={setOpenAlert}
            subtitle="¿Está seguro que desea eliminar esta bodega?"
            send={deleteItem}
        />



        <WarehouseEditor
          setLoading={setLoading}
          openEditor={openEditor} 
          setOpenEditor={setOpenEditor}
          warehouse_id={activeItem} 
          loadList={loadList}
        />



    </div>
  );
};